import {ButtonWithIcon} from '@/components/atoms'
import {AccordionItemCustom} from '@/components/molecules/AccordionItemCustom'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {COLOR} from '@/utils/constants/colors'
import {SIZE} from '@/utils/constants/globalStyle'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useMatch, useNavigate} from 'react-router-dom'

export const ComboReviewSection = ({label, content, step}) => {
  const isComboDetailPage = Boolean(useMatch(ROUTES.PRODUCT_COMBO_DETAIL))
  const navigate = useNavigate()

  const {setCurrentStep, productCombo} = useProductCombo()

  const handleEditClick = () => {
    if (isComboDetailPage) {
      navigate(ROUTES.CREATE_PRODUCT_COMBINATION, {
        state: {
          productCombo: productCombo,
          step,
        },
      })
    }
    setCurrentStep(step)
  }

  return (
    <AccordionItemCustom
      isDark
      size="large"
      expanded={true}
      label={<span className="font-medium">{label}</span>}
      rightAccessoryChild={
        <div
          className="ml-4"
          onClick={e => e.stopPropagation()}
          role="presentation"
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.stopPropagation()
            }
          }}
        >
          <ButtonWithIcon
            iconLeading="edit"
            handleButton={handleEditClick}
            uiSchema={{
              title: 'Edit',
              size: SIZE.SMALL,
              variant: COLOR.TERTIARY,
            }}
          />
        </div>
      }
      content={content}
    />
  )
}
